export const environment = {
  "production": false,
  "api_secure": "https://api-sandbox3.tidy.com/",
  "api_url": "https://api-sandbox3.tidy.com/",
  "aws_access_key_id": "AKIA236WTUK5QJVMFHTB",
  "aws_s3_bucket": "samantha-temp-file-uploads/sandbox3",
  "aws_s3_bucket_url": "https://samantha-temp-file-uploads.s3-us-west-2.amazonaws.com/sandbox3/",
  "aws_s3_region_bucket": "us-west-2",
  "aws_secret_access_key": "o/RGXmHt9KEw7APZs2dYZQ/VW+er/Pe15d/yWLwf",
  "client_id_login": "e12bd5b585513afcfef9a8882eea74032330e72426529aafc4d3df494ce0f510d8c",
  "client_id_signup": "01c9c4890bb589178968522d2f6dda967f43de7b0c7dcbbf87535678144645fe",
  "client_secret_login": "59ca0b90c540b0fcda398dd724ea2e369f2a4b9c10051cf33044a980433bf7ea",
  "client_secret_signup": "6f453631de46a0191a63b37143f65a717e8b0f62b6d88d36d354d9f8bc463ca9",
  "customer_portal": "https://ca-sandbox3.tidy.com/",
  "facebook_app_key": "172422970167712",
  "facebook_pixel_id": "1708273092789855",
  "firebase_project_number": "360634738950",
  "google_analytics_id": "AW-968467335",
  "google_geocode_api": "https://maps.googleapis.com/maps/api/geocode/json?place_id=",
  "google_geocode_key": "&key=AIzaSyA_mFB5HA2_m7rlRSg4tYuLA-Jy9TbLFtQ",
  "launchdarkly_key": "591c4d4a4c9bf909f5a8887b",
  "loggly_tag": "fe-ca-sandbox3",
  "one_signal_app_id": "8ec8d338-41e9-4c62-8fff-43665851eaa7",
  "segment_key": "1wagkLzRGrQ0r4iZSB16afCMHZEA0dkR",
  "stripe_key": "pk_test_VMS0aHewM2yjQhJNlWOcAsZt",
  "recaptcha_site_key": "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  "version": "1",
  "thumbtack_auth_token": "VGlkeTpOa29XQWUzX1ZTQktZR3hUVnN4ZzhtVkJPX2drbUZUcmJqWDFrRkpmUDRnPQ==",
  "sentry_auth_token": "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",
  "environment": "sandbox3",
  "google_web_client_id": "408117769194-qsa2gml4qcdt0ormsrmag7tpiuuqso27.apps.googleusercontent.com",
  "google_ios_client_id": "408117769194-p2ku9po77u3rojp1u3qj0u0eha2o0j5p.apps.googleusercontent.com",
  "google_android_client_id": "408117769194-h37e48cok2hdop76mpddu2l062fik2ra.apps.googleusercontent.com",
  "apple_client_id": "com.tidy.clientmobile",
  "apple_redirect_uri": "https://ca-v2-sandbox3.tidy.com/api/v1/auth/apple/callback",
  "chat_api_url": "https://chat-api.tidy.com",
  "posthog_api_key": "phc_lSSM1gLB0s1hER0eJ4nO7ewwyKtREViWXUlXy9fQBGD",
  "posthog_host": "https://us.i.posthog.com",
  "posthog_web_host": "/a",
  "posthog_enabled": true,
  "pmsites_url": "https://x.tidy.com"
}

import 'zone.js/plugins/zone-error';
